// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3cl4d","title":"Images45_title__uiGf_","images":"Images45_images__17Vh-"};